module.exports = __webpack_public_path__ + "static/img/searchPeople.0a2c905.svg";